import React, { useState } from 'react';
import { Button } from 'react-bootstrap';
import ReactTable from 'react-table';
import 'react-table/react-table.css';
import { connect } from 'react-redux';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEdit, faTrashAlt } from '@fortawesome/free-solid-svg-icons';
import EditSkillItem from '../EditSkillItem';
import { deleteSkill } from '../../redux/reduxActions/actions';
import DeleteModal from './DeleteSkillModal';

function SkillTable(props) {
  const [showModal, setShowStatement] = useState(false);
  const [showDeleteModal, setShowStatementDeleteModal] = useState(false);
  const [oneItem, setItemToEdit] = useState({});
  const [oneItemToDelete, setItemToDelete] = useState({});
  const {
    priorities, jobCategories, qualifications, taskList,
  } = props;
  const show = () => {
    setShowStatement(!showModal);
  };
  const showDelete = () => {
    setShowStatementDeleteModal(!showDeleteModal);
  };
  const editSkill = (data) => {
    setItemToEdit(data);
    show();
  };
  const deleteCategory = (data) => {
    setItemToDelete(data);
    showDelete();
  };
  const skillsTable = [
    {
      Header: 'Priority',
      Cell: ({ original }) => (
        <p>{priorities[original.priority_id]}</p>
      ),
      width: 85,
    },
    {
      Header: 'Categories',
      Cell: ({ original }) => (
        <p>{jobCategories[original.category_id]}</p>
      ),
      width: 160,
    },
    {
      Header: 'Level',
      Cell: ({ original }) => (
        <p>{qualifications[original.qualification_id]}</p>
      ),
      width: 90,
    },
    {
      Header: 'Min \npayment',
      accessor: 'min_rate',
      width: 100,
    },
    {
      Header: 'Normal payment',
      accessor: 'rate',
      width: 100,
    },
    {
      Header: 'Additional information',
      accessor: 'description',
    },
    {
      id: 'actions',
      Cell: ({ original }) => (
        <Button onClick={() => { editSkill(original); }} variant="outline-info" className="main-button">
          <FontAwesomeIcon style={{ marginLeft: '3px' }} icon={faEdit} />
        </Button>
      ),
      Header: 'edit',
      className: 'centered',
      width: 70,
    },
    {
      id: 'delete',
      Cell: ({ original }) => (
        <Button onClick={() => { deleteCategory(original); }} variant="outline-danger">
          <FontAwesomeIcon style={{ marginLeft: '3px' }} icon={faTrashAlt} />
        </Button>
      ),
      Header: 'delete',
      className: 'centered',
      width: 70,
    }];
  return (
    <div>
      <ReactTable
        data={taskList}
        columns={skillsTable}
        style={{
          marginTop: '10px',
        }}
        minRows={4}
        showPagination={false}
        className="-striped -highlight"
      />
      <EditSkillItem show={() => { show(); }} isOpen={showModal} itemData={oneItem} />
      <DeleteModal
        show={() => { showDelete(); }}
        isOpen={showDeleteModal}
        itemData={oneItemToDelete}
      />
    </div>
  );
}

const mapStateToPropsTable = (state) => ({
  taskList: state.skillsReducer.skillList,
  priorities: state.skillsReducer.priorities,
  qualifications: state.skillsReducer.qualifications,
  jobCategories: state.skillsReducer.jobCategories,
});
export default connect(mapStateToPropsTable, { deleteSkill })(SkillTable);
